import { css } from '@emotion/react';

export const getAccordionPanelCss = css`
  margin: 0 var(--cds-spacing-200) var(--cds-spacing-200) var(--cds-spacing-200);
`;
